module.exports = __webpack_public_path__ + "public/img/pt.c58d209c.png";